import React, { useEffect, useState } from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    MenuItem,
    Box,
    TextField,
    CircularProgress
} from '@mui/material';
import { Search as SearchIcon, CleaningServices as CleaningServicesIcon } from '@mui/icons-material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { useProdutosStore } from '../store/ProdutosStore';

export default function FiltroDeVendas({ onSearch, isLoading }) {
    const [formData, setFormData] = useState({
        data_inicio: null,
        nome_produto: '',
        data_fim: null,
        grupo: '',
        subgrupo: '',
        qtd_registros: 10
    });

    const { fetchGruposEsubgrupos, grupos, sub_grupos } = useProdutosStore()

    useEffect(() => {
        fetchGruposEsubgrupos()
    }, [])

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleDateChange = (name, newValue) => {
        setFormData(prev => ({ ...prev, [name]: newValue }));
    };

    const HandleClearSeartch = () => {
        setFormData({
            nome_produto: '',
            data_inicio: null,
            data_fim: null,
            grupo: '',
            subgrupo: '',
            qtd_registros: 10
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            data_inicio: formData.data_inicio ? dayjs(formData.data_inicio).format('YYYY-MM-DD') : null,
            data_fim: formData.data_fim ? dayjs(formData.data_fim).format('YYYY-MM-DD') : null,
        };
        onSearch(payload);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
            <DialogContent>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <TextField
                                InputProps={{
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                                fullWidth
                                label="Nome do produto"
                                variant="outlined"
                                name="nome_produto"
                                value={formData.nome_produto}
                                onChange={handleChange}

                            />

                        </Grid>
                        <Grid size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <DatePicker
                                label="Data início"
                                sx={{ width: '100%' }}
                                value={formData.data_inicio}
                                onChange={(newValue) => handleDateChange('data_inicio', newValue)}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        InputProps: {
                                            sx: {
                                                backgroundColor: 'white',
                                                color: 'black'
                                            },
                                        },
                                        InputLabelProps: {
                                            sx: {
                                                bgcolor: 'white',
                                                px: 0.5,
                                                color: 'black'
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <DatePicker
                                label="Data fim"
                                sx={{ width: '100%' }}
                                value={formData.data_fim}
                                onChange={(newValue) => handleDateChange('data_fim', newValue)}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        InputProps: {
                                            sx: {
                                                backgroundColor: 'white',
                                                color: 'black'
                                            },
                                        },
                                        InputLabelProps: {
                                            sx: {
                                                bgcolor: 'white',
                                                px: 0.5,
                                                color: 'black'
                                            },
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Grupos"
                                name="grupo"
                                value={formData.grupo}
                                onChange={handleChange}
                                size="small"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                            >
                                {grupos.map((grup) => {
                                    return (

                                        <MenuItem value={grup.cod_grupo}>{grup?.nome || "Não informado"}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>

                        <Grid size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Subgrupos"
                                name="subgrupo"
                                value={formData.subgrupo}
                                onChange={handleChange}
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                size="small"
                            >
                                {sub_grupos.map((grup) => {
                                    return (
                                        <MenuItem value={grup.cod_subgrupo}>{grup?.nome || "Não informado"}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>

                        <Grid size={{ sx: 1, sm: 12, md: 4, lg: 3, xl: 1, xs: 12 }}>
                            <TextField
                                fullWidth
                                label="Quantidade de registros"
                                name="qtd_registros"
                                value={formData.qtd_registros}
                                onChange={handleChange}
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }} size="small"
                            />

                        </Grid>
                    </Grid>
                </LocalizationProvider>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => { HandleClearSeartch() }} type="button" variant="outlined" endIcon={<CleaningServicesIcon />}>
                    Limpar
                </Button>
                <Button
                    type="submit"
                    variant="outlined"
                    startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
                    disabled={isLoading}
                >
                    Pesquisar
                </Button>
            </DialogActions>
        </Box>
    );
}